<template>
  <div ref="product">
    <v-row
      no-gutters
      class="flex-xs-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-lg-space-between justify-md-space-between"
    >
      <v-col lg="5" md="5" xl="5">
        <h1 :class="titleStyle">Simplifica {{ simplify[0] }} con MerloCode.</h1>
        <div class="mb-5 body-1" id="product">
          MerloCode
          <strong>te ofrece crear y gestionar tu propia carta digital</strong>,
          ser notificado por tus clientes y realizar el seguimiento de los
          pedidos. <br />Posibilita <strong>a tus clientes</strong> realizar
          pedidos y pagos o llamar al camarero desde su móvil
          <strong>sin necesidad de instalar ninguna aplicación</strong>.
        </div>
      </v-col>
      <v-col lg="7" md="7" xl="7">
        <v-img
          :src="require('../assets/merloimage.png')"
          class="my-3"
          contain
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Description",
  data() {
    return { simplify: ["", "tu carta", "el servicio"] };
  },

  computed: {
    titleStyle() {
      return `display-3 my-md-3 my-lg-3 my-xl-3 pb-5 font-weight-bold simplify`;
    },
  },

  mounted() {
    let that = this;
    setInterval(function() {
      that.changeItem();
    }, 3000);
  },
  methods: {
    changeItem() {
      this.simplify.push(this.simplify.shift());
    },
  },
};
</script>

<style>
.simplify {
  height: 3.2em;
}
</style>
